import { FunctionComponent, h } from 'preact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlink } from '@fortawesome/pro-light-svg-icons/faUnlink';
import Translate from '../translate/translate';

const NotFoundMessage: FunctionComponent = () => {
	return (
		<div className="not-found-message">
			<FontAwesomeIcon className="not-found-icon" icon={faUnlink} />
			<div className="not-found-title">
				<Translate text="PAGE_NOT_FOUND" />
			</div>
			<div className="not-found-description">
				<Translate text="COULD_NOT_FIND_PAGE" />
			</div>
		</div>
	);
};

export default NotFoundMessage;
